import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import SignUpLangSelector from "../SignUpLangSelector";
import { ReactComponent as CrosspointLogo } from "assets/svg/crosspoint-logo.svg";
import { Locations } from "interfaces/enums";
import { Button, Input } from "components/Shared";
import { useForm } from "react-hook-form";
import { IForgotPasswordForm } from "interfaces";

const ForgotPassword = ({
  onEmailChange,
  email,
  error,
  onSubmit,
}: {
  onEmailChange: any;
  email?: string;
  error: any;
  onSubmit: any;
}) => {
  const { t } = useTranslation();

  const { user } = useAuth();

  const { handleSubmit } = useForm<IForgotPasswordForm>();

  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const handleSubmitResetPassword = async (e: any) => {
    e.preventDefault();
    try {
      setIsSendingEmail(true);
      await onSubmit(email);
    } catch (err: any) {
      console.error("err.message: ", err.message);
    } finally {
      setIsSendingEmail(false);
    }
  };

  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate(Locations["/login"]);
  };

  return (
    <>
      {user ? (
        <Navigate to={Locations["/"]} replace={true} />
      ) : (
        <div className="p-4 sm:px-8 sm:py-0 flex gap-6 flex-col">
          <div className="justify-end absolute end-10 top-6 hidden sm:flex">
            <SignUpLangSelector theme="light" />
          </div>
          <div className="bg-white h-full w-full">
            <div className="fixed p-8">
              <CrosspointLogo />
            </div>
            <div className="flex flex-col pt-[8rem] justify-center items-center">
              <div className="flex flex-col gap-6">
                <span className="text-primary font-sans">
                  {t("Reset Password")}
                </span>
                <p className="text-sm">
                  {t(
                    "Enter your email to receive a link with the steps to reset your password",
                  )}
                  .
                </p>
                <form onSubmit={handleSubmit(handleSubmitResetPassword)}>
                  <div className="pt-6">
                    <Input
                      type="email"
                      placeholder={t("Email")}
                      className="border-b border-gray-dark200  hover:border-black focus:border-black hover:shadow-[inset_0_-1.3px_0_0_black] focus:shadow-[inset_0_-1.3px_0_0_black] placeholder-gray-dark100"
                      onChange={(e: any) => onEmailChange(e.target.value)}
                    />
                  </div>
                  <div className="pt-6 flex flex-col gap-2 items-end">
                    <Button
                      onClick={onSubmit}
                      className="w-full"
                      disabled={error || !email || isSendingEmail}
                    >
                      {t("Confirm")}
                    </Button>
                    <Button
                      onClick={handleNavigateBack}
                      variant="outline"
                      className="w-full"
                    >
                      {t("Go back")}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
